import { useState } from 'react';
import {
	IMenuItemEntry,
	IOtherWebsitesEntry,
} from '../../../../contentful/types/IMenuItem';
import { CancelIcon, Flex } from '../../../../ui';
import GlobalSearch from '../../global-search/GlobalSearch';
import { useGetWebsiteDetails } from '../hooks/useSiteSectionDetails';
import { MenuButton } from '../menu-btn/MenuButton';
import { NavigationItems } from '../shared/NavigationItems';
import { NavigationWrapper } from '../shared/NavigationWrapper';
import MobileBackButton from './MobileBackButton';
import {
	MenuCloseButton,
	MenuLabel,
	MobileHeader,
	MobileMenu,
} from './MobileNavigation.styles';
import { getReciteMeBarHeight } from '../../../../utils/getReciteMeBarHeight';

interface IMobileNavigationProps {
	isSticky: boolean;
	className?: string;
}

export default function MobileNavigation({
	isSticky,
	className,
}: IMobileNavigationProps) {
	const { menuItems } = useGetWebsiteDetails();
	const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
	const [selectedMenuItem, setSelectedMenuItem] = useState<
		IMenuItemEntry | IOtherWebsitesEntry | undefined
	>(undefined);

	const toggleMobileMenu = () => {
		setIsMobileMenuOpen(!isMobileMenuOpen);
	};

	const onMenuItemClick = (
		item: IMenuItemEntry | IOtherWebsitesEntry | undefined,
	) => {
		setSelectedMenuItem(item);
	};

	const stickyTop = getReciteMeBarHeight();

	return (
		<>
			<MobileMenu open={isMobileMenuOpen} stickyTop={stickyTop}>
				<MobileHeader>
					<MenuLabel>
						<MobileBackButton selectedItem={selectedMenuItem} />
					</MenuLabel>
					<MenuCloseButton
						buttonType="textButton"
						onClick={toggleMobileMenu}
						aria-label="Close"
						icon={<CancelIcon />}
					/>
				</MobileHeader>

				{menuItems && <NavigationItems onClick={onMenuItemClick} />}
			</MobileMenu>

			{!isMobileMenuOpen && (
				<NavigationWrapper
					className={className}
					aria-hidden={isMobileMenuOpen}
					isLogoVisible={!isMobileMenuOpen}
					isSticky={isSticky}
				>
					<Flex gap={8} alignItems="center">
						<GlobalSearch />
						<MenuButton onClick={toggleMobileMenu} />
					</Flex>
				</NavigationWrapper>
			)}
		</>
	);
}
